export default "__VITE_ASSET__CQalQKaW__"